import { Action, Reducer } from "redux";
import { AddressState, AddressTypes, AddressActionTypes } from "./addressTypes";
import { haskeyReducer, updateGetIsolated, updateSaveIsolated } from "@/main/services/reducerUtils";

export const INITIAL_STATE: AddressState = {
	address: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	isolated: {},
};

const addressReducer: Reducer<AddressState> = (state: AddressState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as AddressActionTypes;
	switch (actionTypes.type) {
		case AddressTypes.GET_ADDRESS: {
			const isKeyReducer = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducer) return updateGetIsolated(state, actionTypes);

			return {
				...state,
				address: { ...state.address, isLoading: true },
			};
		}
		case AddressTypes.SAVE_ADDRESS: {
			const isKeyReducerSave = haskeyReducer(actionTypes.payload.keyReducer);

			if (isKeyReducerSave) return updateSaveIsolated(state, actionTypes);

			return {
				...state,
				address: {
					...state.address,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		}
		case AddressTypes.RESET_REDUCER_ADDRESS:
			return {
				...state,
				address: INITIAL_STATE.address,
			};
		default:
			return state;
	}
};

export default addressReducer;
